export default duration => ({
  hours: (Math.floor(duration / 3600)).toString(),
  minutes: ((duration % 3600) / 60).toString(),
})
